import React, {useEffect, useState} from "react"

import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import {ColorPalette} from "../../../../../fields3/color-coding/color-coding"
import PopoverMenuSeparator from "../../../../../gd-components/popover-menu/popover-menu/popover-menu-separator"
import Project from "../../../../../model2/project/project"
import {PROJECT_COLOR_OPTIONS} from "../../../../../fields3/generic/color/color"
import ApiProject from "../../../../../gd/api/project"
import {ProjectSystemTypeIcon} from "../../../../../model2/project/types";
import {ProjectIconsOptionsList} from "../../../../../gd/const/item-icon/project";
import ProjectSession from "../../../../../model2/project/project-session";
import {ItemIconClass} from "../../../../../gd/const/item-icon/icon/item-icon-class";

type Props = {
    options?        : any[] | null
    menuParams: {
        project         : Project,
        hidePopover     : callback
    }
}

// const debug = "MoreProject_PopoverColorIcon"
const debug = false

export default function MoreProject_PopoverColorIcon(props:Props) {

    const project = props.menuParams.project

    // use it because model might have no color but project in session always have
    const sessionProject : ProjectSession = gd.session.projects.get(props.menuParams.project.id)!

    const [color, setColor] = useState<number|undefined>()
    const [icon, setIcon]   = useState<string|undefined>()

    useEffect(() => {
        const projectIcon = sessionProject.projectIcon ? sessionProject.projectIcon : ProjectSystemTypeIcon[sessionProject.systemType]

        setColor(sessionProject.color)
        setIcon(projectIcon)
    }, [sessionProject.color, sessionProject.projectIcon, sessionProject.systemType])

    const onColorSelect = (color:number) => {
        sessionProject.color = color
        setColor(color)
        ApiProject.updateNew(project.id, {
            color: color
        })
    }

    const onIconSelect = (icon:string) => {
        sessionProject.projectIcon = icon
        setIcon(icon)
        ApiProject.updateNew(project.id, {
            projectIcon: icon
        })
    }

    const onApplyToChildren = ()=>{
        props.menuParams.hidePopover()

        gd.modals.confirm.genericText("Are you sure ?","Are you sure you want to apply the current color to all the child folders?",
            async ()=>{
                await ApiProject.applyColorToChildren(project.id)
                gd.modal.hide()
            }
        )
    }

    const showApplyToSubfolders = !project.isTag

    debug && console.log(debug, 'render', color, icon)

    return (
        <VScroll containerClass="color-with-icon ui5-popover-menu max-h-500">
            <div className="flex-column-left-top">
                <div className="flex-row-left-center ui5-txt-not-important ui5-txt-bold h-36 p-l-10">Change color</div>

                <div className="ui5-popover-selector color-picker w-320 p-t-10">
                    {_.map(PROJECT_COLOR_OPTIONS, (option:Option)=> {

                        const classes = Classes("ui5-color-picker",{
                            'is-selected'   : option.value === color
                        })

                        const style : style = {
                            backgroundColor: gd.skin.colors.mainColor({
                                colorNumber: option.value,
                                corePalette: ColorPalette.CORE
                            })
                        }

                        return (
                            <div key        = {option.value}
                                 className  = {classes}
                                 style      = {style}
                                 onClick    = {()=>onColorSelect(option.value)}/>
                        )
                    })}
                </div>

                {showApplyToSubfolders &&
                    <div className="flex-row-right-center p-r-20 w-100-percent border-box m-b-10">
                        <div className="ui5-link-small" onClick={onApplyToChildren}>
                            <div className="ui5-ico-13 i5-color link m-r-5" />
                            Apply to subfolders
                        </div>
                    </div>}
            </div>

            <PopoverMenuSeparator/>

            <div className="flex-column-left-top">
                <div className="flex-row-left-center ui5-txt-not-important ui5-txt-bold h-36 p-l-10">Change icon</div>
                <div className="ui5-popover-selector icon-selector p-t-0">
                    {_.map(ProjectIconsOptionsList, (group: string[], key: number) =>
                        <div className="icons-group" key={key}>
                            {_.map(group, (value: string, key: number) => {
                                const classes = Classes("block", {
                                    selected: value === icon
                                })

                                return (
                                    <div className={classes} key={key} onClick={() => {
                                        onIconSelect(value)
                                    }}>
                                        <div className={"icon " + ItemIconClass[value]}></div>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </div>
            </div>

        </VScroll>
    )
}

